<template>
  <div class="wrapper-with-navbar">
    <router-view />
  </div>
</template>
